// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your config
const firebaseConfig = {
  apiKey: "AIzaSyBVwY2BW6dQX_FYpeGlkxfLJtk1toegIIM",
  authDomain: "ai-chat-app-db2f2.firebaseapp.com",
  projectId: "ai-chat-app-db2f2",
  storageBucket: "ai-chat-app-db2f2.appspot.com",
  messagingSenderId: "1040849214049",
  appId: "1:1040849214049:web:9f35c247c9019a304ae820",
  measurementId: "G-4PXEV4XH3R"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Auth & Firestore
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

// Export everything needed
export { auth, provider, db };
